import { make_staircase, time_mul_1k, normalize_time, } from './common';
import { GraphSource, TemperatureGraphData, TooltipSeries } from './base';
import { LoadDataType } from '../load-types';
export class GTWModeGraphSource extends GraphSource {
    class_name() {
        return 'GTWModeGraphSource';
    }
    title() {
        return 'режим';
    }
    show_in_legend() {
        return false;
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    extract_data(raw_data) {
        return raw_data?.oven_mode;
    }
    normalize_data(data) {
        return normalize_time(data, 0);
    }
    create_series() {
        return null;
    }
    series_from_norm_data([mintime, maxtime], norm_data) {
        return [
            new TooltipSeries({
                data: norm_data,
                html_formatter: (value) => this._mode_name(value),
            }),
        ];
    }
    _mode_name(mode) {
        switch (mode) {
            case 'off':
                return 'Выключен';
            case 'water':
                return 'Водонагрев';
            case 'floor':
                return 'Тёплый пол';
            case 'air':
                return 'Комнатный';
            case 'week':
                return 'Недельный';
            case 'party':
                return 'Вечеринка';
            case 'econom':
                return 'Эконом';
            case 'workday':
                return 'Рабочий день';
            case 'weekend':
                return 'Выходной день';
            default:
                return 'Неизвестный';
        }
    }
}
export class GTWPWaterGraphSource extends GraphSource {
    class_name() {
        return 'GTWPWaterGraphSource';
    }
    title() {
        return 'давление воды';
    }
    color() {
        if (this._color)
            return this._color;
        else
            return '#9440ed';
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    yaxis_key() {
        return 'pressure';
    }
    extract_data(raw_data) {
        return raw_data?.p_water;
    }
    normalize_data(data) {
        return make_staircase(time_mul_1k(normalize_time(data, 0)));
    }
}
export class GTWTenCountGraphSource extends GraphSource {
    class_name() {
        return 'GTWTenCountGraphSource';
    }
    title() {
        return 'количество ТЭНов';
    }
    color() {
        if (this._color)
            return this._color;
        else
            return '#103ca0';
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    yaxis_key() {
        return 'count';
    }
    extract_data(raw_data) {
        return raw_data?.ten_count;
    }
    normalize_data(data) {
        return make_staircase(time_mul_1k(normalize_time(data, 0)));
    }
}
export class GTWTAirIntGraphSource extends TemperatureGraphData {
    class_name() {
        return 'GTWTAirIntGraphSource';
    }
    title() {
        return 't° воздуха комнатная';
    }
    color() {
        if (this._color)
            return this._color;
        else
            return '#4da74d';
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    extract_data(raw_data) {
        return raw_data?.t_air_int;
    }
}
export class GTWTAirExtGraphSource extends TemperatureGraphData {
    class_name() {
        return 'GTWTAirExtGraphSource';
    }
    title() {
        return 't° воздуха уличная';
    }
    color() {
        if (this._color)
            return this._color;
        else
            return '#24b5c4';
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    extract_data(raw_data) {
        return raw_data?.t_air_ext;
    }
}
export class GTWTWaterGraphSource extends TemperatureGraphData {
    class_name() {
        return 'GTWTWaterGraphSource';
    }
    title() {
        return 't° воды';
    }
    color() {
        if (this._color)
            return this._color;
        else
            return '#cb4b4b';
    }
    data_source_key() {
        return LoadDataType.gtw_report;
    }
    extract_data(raw_data) {
        return raw_data?.t_water;
    }
}
